import { db } from "../utils/firebase/Firebase.utils";
import { doc, getDoc } from "firebase/firestore";

export const getParcelById = async (parcelId) => {
  try {
    const parcelRef = doc(db, "parcels", parcelId);
    const parcelDoc = await getDoc(parcelRef);

    if (!parcelDoc.exists()) {
      throw new Error("Parcel not found");
    }

    return {
      id: parcelDoc.id,
      ...parcelDoc.data(),
    };
  } catch (error) {
    console.error("Error fetching parcel:", error);
    throw error;
  }
};
